<template>
  <div class="stlc_padding_bottom_15px stlc__height_default storelocater-col-md-12">
    <template v-for="(saItem, index) in storeAttributes">
      <h5 v-if="saItem.Options && saItem.Options.length && saItem.ShowInList" :key="'sah_' + index">
        {{ saItem.Name }}
      </h5>
      <div
        v-if="saItem.Options && saItem.Options.length && saItem.ShowInList"
        :key="'sab_' + index"
        class="stlc_icon_list_container stlc_social_networks"
      >
        <template v-for="(optionItem, optionIndex) in saItem.Options">
          <component
            :is="optionItem.AttributeUrl ? 'a' : 'span'"
            v-if="optionItem"
            :key="'sao_' + optionIndex"
            :href="optionItem.AttributeUrl"
            :title="optionItem.Name"
            class="stlc_list_icon_item"
            target="_blank"
          >
            <img
              v-if="optionItem.AttributeIconUrl"
              :alt="optionItem.Name"
              :src="optionItem.AttributeIconUrl"
              class="stlc-store-list-icons"
            />
            <span v-if="optionItem.AttributeText">
              {{ optionItem.AttributeText }}
            </span>
          </component>
          <span
            v-if="doInsertLineBreaks(saItem.Options)"
            :key="optionIndex"
            class="stlc_break_line"
          ></span>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'rfp-storelocator-store-attributes',
  props: {
    storeAttributes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    doInsertLineBreaks(storeAttributeOptions) {
      if (storeAttributeOptions && storeAttributeOptions.length) {
        return storeAttributeOptions.some((a) => a.AttributeText);
      }

      return false;
    },
  },
};
</script>
